<template>
  <div class="search-picker" @mouseleave="openState = false" @mouseenter="openState = true">
    <div class="input-placeholder" v-on:click.self="openState = true">
      <div class="input-icon">
        <img src="/static/img/map-marker-check-light.svg" alt="">
      </div>
      <span class="value" v-if="value">{{ value }}</span>
      <span class="value" v-else>{{ $t('v2.zone.mainZone') }}</span>
    </div>
    <div class="picker-dropdown" :class="{ open: openState }">
      <div class="list-item"
           v-for="(zone, index) in zones"
           :index="index"
           :key="zone.id ? zone.id : 'unique'"
           :class="{ active: isZoneActive(zone.id) }"
           @click="choose(zone.id)">
        <span v-if="zone.name">{{ zone.name }}</span>
        <span v-else>{{ $t('v2.zone.mainZone') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "search-zone-picker",
  computed: {
    ...mapState({
      zones: s => {
        return [{ id: null, name: null }].concat(s.search.availableRoomZones);
      },
      currentZone: s => s.search.search.zone,
      value: s => {
        const zone = s.search.search.zone;
        if (Array.isArray(zone) && [1, 2, 3].every(id => zone.includes(id)) && zone.length === 3) {
          return "Lyon – toutes les suites";
        }

        const zones = s.search.availableRoomZones;
        for (const z of zones) {
          if (z.id === zone) return z.name;
        }
        return null;
      }
    })
  },
  data() {
    return {
      openState: false
    };
  },
  methods: {
    isZoneActive(id) {
      const zone = this.currentZone;
      if (Array.isArray(zone)) return zone.includes(id);
      return id === zone;
    },
    choose(id) {
      if (id === null) {
        // Clique sur "Toutes les suites" → force zones 1, 2, 3
        this.$store.commit("search/SET_SEARCH_ZONE", [1, 2, 3]);
      } else {
        this.$store.commit("search/SET_SEARCH_ZONE", id);
      }
      this.openState = false;
    }
  },
  mounted() {
    if (this.$store.state.search.search.zone === null) {
      this.$store.commit("search/SET_SEARCH_ZONE", [1, 2, 3]);
    }
    this.$store.dispatch('search/process', { runAuto: true });
  }
};
</script>

<style scoped>
.picker-dropdown:not(.open) {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/search/picker/search-zone-picker.vue